declare const THREE: any;

export class Line extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static transformation = new THREE.Matrix4()
    .makeRotationX(THREE.Math.degToRad(-90))
    .multiply(new THREE.Matrix4().makeTranslation(-0.5, 0, 0));

  constructor(firstpoint, secondPoint) {
    const geometry = new THREE.PlaneBufferGeometry(1, 2).applyMatrix(Line.transformation);
    const material = new THREE.MeshBasicMaterial({
      color: 0x9c9c9c,
      side: THREE.DoubleSide
    });
    super(geometry, material);
    this.update(firstpoint, secondPoint);
    this.position.copy(firstpoint);
  }

  private update(firstPoint, secondPoint) {
    this.scale.x = firstPoint.distanceTo(secondPoint);
    this.rotation.y = -Math.atan2(secondPoint.z - firstPoint.z, secondPoint.x - firstPoint.x) + THREE.Math.degToRad(-180);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Floor/Line.ts